import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import {
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Entry2xmjmyutzoq3p as Entry,
} from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysClass;
function HashMapKeys() {
  if (HashMapKeysClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor(backing) {
        return new.target.l9(backing);
      }
      static l9(backing) {
        var $this = this.c8();
        $this.k9_1 = backing;
        return $this;
      }
      q2() {
        return this.k9_1.q2();
      }
      n1() {
        return this.k9_1.q2() === 0;
      }
      t2(element) {
        return this.k9_1.j9(element);
      }
      y4() {
        return this.k9_1.y4();
      }
      j2(element) {
        throw UnsupportedOperationException().k8();
      }
      u2(elements) {
        throw UnsupportedOperationException().k8();
      }
      p1() {
        return this.k9_1.q9();
      }
      p6() {
        return this.k9_1.r9();
      }
    }
    initMetadataForClass($, 'HashMapKeys', VOID, VOID, [KtMutableSet()]);
    HashMapKeysClass = $;
  }
  return HashMapKeysClass;
}
var HashMapValuesClass;
function HashMapValues() {
  if (HashMapValuesClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor(backing) {
        return new.target.n9(backing);
      }
      static n9(backing) {
        var $this = this.n6();
        $this.m9_1 = backing;
        return $this;
      }
      q2() {
        return this.m9_1.q2();
      }
      n1() {
        return this.m9_1.q2() === 0;
      }
      s9(element) {
        return this.m9_1.u4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.s9(element);
      }
      t9(element) {
        throw UnsupportedOperationException().k8();
      }
      j2(element) {
        return this.t9(element);
      }
      u9(elements) {
        throw UnsupportedOperationException().k8();
      }
      u2(elements) {
        return this.u9(elements);
      }
      p1() {
        return this.m9_1.v9();
      }
      p6() {
        return this.m9_1.r9();
      }
    }
    initMetadataForClass($, 'HashMapValues', VOID, VOID, [Collection(), MutableIterable()]);
    HashMapValuesClass = $;
  }
  return HashMapValuesClass;
}
var HashMapEntrySetClass;
function HashMapEntrySet() {
  if (HashMapEntrySetClass === VOID) {
    class $ extends HashMapEntrySetBase() {
      constructor(backing) {
        return new.target.p9(backing);
      }
      static p9(backing) {
        return this.x9(backing);
      }
      p1() {
        return this.w9_1.y9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySet');
    HashMapEntrySetClass = $;
  }
  return HashMapEntrySetClass;
}
var HashMapEntrySetBaseClass;
function HashMapEntrySetBase() {
  if (HashMapEntrySetBaseClass === VOID) {
    class $ extends AbstractMutableSet() {
      static x9(backing) {
        var $this = this.c8();
        $this.w9_1 = backing;
        return $this;
      }
      q2() {
        return this.w9_1.q2();
      }
      n1() {
        return this.w9_1.q2() === 0;
      }
      z9(element) {
        return this.w9_1.ba(element);
      }
      t2(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.z9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      y4() {
        return this.w9_1.y4();
      }
      aa(element) {
        throw UnsupportedOperationException().k8();
      }
      j2(element) {
        return this.aa((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      u2(elements) {
        throw UnsupportedOperationException().k8();
      }
      r4(elements) {
        return this.w9_1.ca(elements);
      }
      p6() {
        return this.w9_1.r9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySetBase', VOID, VOID, [KtMutableSet()]);
    HashMapEntrySetBaseClass = $;
  }
  return HashMapEntrySetBaseClass;
}
//region block: exports
export {
  HashMapEntrySet as HashMapEntrySet29p2ksc4wcy5i,
  HashMapKeys as HashMapKeys28ggmxpft3hz9,
  HashMapValues as HashMapValues3umcxpfyfunqf,
};
//endregion

//# sourceMappingURL=HashMapEntry.mjs.map
